import React, { useState } from 'react';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import Heading from '../../components/common/Heading/Heading';
import { App, Button, Popconfirm, Popover, Space } from 'antd';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  deleteServiceUnits,
  getServiceUnits,
} from '../../network/serviceUnits';
import { queryKeys } from '../../services/react-query/queryKeys';
import { ModalAppServices } from '../../components/upeosoft/ModalApp/ModalApp';
import { PlusOutlined } from '@ant-design/icons';

const ServiceUnits = ({ t }) => {
  const [searchText, setSearchText] = useState('');
  const client = useQueryClient();
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { message } = App.useApp();
  const handleRemove = useMutation(
    // (id) => deletePatient(id),
    {
      mutationFn: (id) => deleteServiceUnits(id),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message);
        client.invalidateQueries({ queryKey: [queryKeys.getServiceUnits] });
      },
      onError: () => {
        message.error('حدث خطأ ما');
      },
    }
  );
  const { data, isError, error, isLoading } = useQuery({
    queryKey: [queryKeys.getServiceUnits],
    queryFn: () => getServiceUnits(),
    keepPreviousData: true,
  });
  const columns = [
    {
      title: t.serviceUnitName,
      dataIndex: 'healthcare_service_unit_name',
      filteredValue: [searchText],
      onFilter: (value, record) => {
        const name = String(record.healthcare_service_unit_name).toLowerCase();
        const searchValue = value.toLowerCase();
        // console.log(record);
        return name.includes(searchValue);
      },
    },
    {
      title: t.allowAppointments,
      dataIndex: 'allow_appointments',
    },
    {
      title: t.inpatientOccupancy,
      dataIndex: 'inpatient_occupancy',
    },
    {
      title: t.serviceUnitType,
      dataIndex: 'service_unit_type',
    },
    {
      title: t.warehouse,
      dataIndex: 'warehouse',
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      render: (text, record) => {
        return (
          <Space>
            {/* <ModalAppServices t={t} edit={true} /> */}
            <Popover
              placement="top"
              title={t.edit}
              onClick={() => {
                setEditId(record?.name);
                setOpen(true);
                setEdit(true);
              }}
            >
              <Button size="small" type="primary">
                <MdModeEditOutline />
              </Button>
            </Popover>
            <Popconfirm
              title={t.DeletetheServiceUnit}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              // onCancel={cancel}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger>
                <MdDelete />
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.message?.service_units?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="service-units">
      <Heading title={t.settings} subTitle={t.serviceUnits} path="/" />
      <DynamicTableAnt
        columns={columns}
        data={dataTable}
        loading={isLoading}
        setSearchText={setSearchText}
        // titleBtn="Add Service Unit"
        buttonModal={
          <Button
            type="primary"
            onClick={() => {
              setOpen(true);
              setEdit(false);
            }}
          >
            <PlusOutlined
              style={{
                fontSize: '10px',
              }}
            />{' '}
            {t.addServiceUnit}
          </Button>
        }
        Placeholder={t.searchServiceUnitName}
        // pathBtn="/service-units/add"
      />
      <ModalAppServices
        t={t}
        edit={edit}
        editId={editId}
        open={open}
        setOpen={setOpen}
      />
    </div>
  );
};

export default ServiceUnits;
